/* tslint:disable */
/* eslint-disable */
/**
 * backend/api/v2beta1/recurring_run.proto
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: version not set
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * Output. The status of the recurring run.
 * @export
 */
export const V2beta1RecurringRunStatus = {
  STATUS_UNSPECIFIED: 'STATUS_UNSPECIFIED',
  ENABLED: 'ENABLED',
  DISABLED: 'DISABLED',
} as const;
export type V2beta1RecurringRunStatus =
  (typeof V2beta1RecurringRunStatus)[keyof typeof V2beta1RecurringRunStatus];

export function instanceOfV2beta1RecurringRunStatus(value: any): boolean {
  for (const key in V2beta1RecurringRunStatus) {
    if (Object.prototype.hasOwnProperty.call(V2beta1RecurringRunStatus, key)) {
      if (V2beta1RecurringRunStatus[key as keyof typeof V2beta1RecurringRunStatus] === value) {
        return true;
      }
    }
  }
  return false;
}

export function V2beta1RecurringRunStatusFromJSON(json: any): V2beta1RecurringRunStatus {
  return V2beta1RecurringRunStatusFromJSONTyped(json, false);
}

export function V2beta1RecurringRunStatusFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): V2beta1RecurringRunStatus {
  return json as V2beta1RecurringRunStatus;
}

export function V2beta1RecurringRunStatusToJSON(value?: V2beta1RecurringRunStatus | null): any {
  return value as any;
}

export function V2beta1RecurringRunStatusToJSONTyped(
  value: any,
  ignoreDiscriminator: boolean,
): V2beta1RecurringRunStatus {
  return value as V2beta1RecurringRunStatus;
}
